/**
 * Colores de los gráficos SVG (VIS-04).
 *
 * Un SVG no lee clases de Tailwind en `fill`/`stroke`, así que acá van los hex
 * de los tokens de `tailwind.config.ts` (paleta Clarke Ecosistema) y de los
 * estados emerald/amber/rose de Tailwind. Sin degradados: barras y trazos
 * planos (DESIGN.md §1 y §8). Si cambia un token, cambiarlo también acá.
 */

export const CHART_COLORS = {
  /** Barras y trazo principal: bronce de marca (sin texto encima). */
  brand600: "#A0763B",
  /** Relleno suave / barra secundaria. */
  brand300: "#DBBF94",
  /** Líneas de grilla. */
  neutral200: "#E7E3DC",
  /** Línea base de los ejes (3,3:1 sobre blanco, mismo token que los controles). */
  neutral450: "#958D81",
  /** Valores del eje Y (4,5:1 sobre blanco). */
  neutral500: "#7D7569",
  /** Etiquetas del eje X. */
  neutral600: "#5F5850",
  /** Estado bueno. */
  emerald600: "#059669",
  /** Estado de atención. */
  amber600: "#D97706",
  /** Estado malo. */
  rose600: "#E11D48",
} as const;

export type ChartColor = (typeof CHART_COLORS)[keyof typeof CHART_COLORS];
